export class Size {
  description: string = ''
  id: string = ''
  label: string = ''
  name: string = ''
  size_code: string = ''

  constructor(data: Partial<Size> = {}) {
    Object.assign(this, data)
  }

  static sizesFromArray(items: any[]): Size[] {
    const sizes: Size[] = [];

    items.forEach(item => {
      sizes.push({
        ...item, ...{ name: `${item.size_code} (${item.description})` }
      })
    });

    return sizes;
  }
}
